import { apiRequest } from "../../utilities/apiHelper";

export async function getSmartBenchmarkingInsightsApi(
  organizationId,
  params
) {
  const url = `${organizationId}/smart-benchmark/ai-insights`;
  return await apiRequest('POST', url, params, false);
}

export async function getSmartBenchmarkingInsightsWorkerApi(
  organizationId,
  workerId
) {
  const url = `${organizationId}/smart-benchmark/ai-insights/${workerId}`;
  return await apiRequest('GET', url, null, false);
}

export async function exportSmartBenchmarkingReportApi(
  organizationId,
  params
) {
  return Promise.resolve({
    status: 'success',
    message: 'Benchmarking report generated successfully',
    downloadUrl: '/dummy/smart-benchmarking-report.pdf',
    generatedAt: new Date().toISOString(),
  });
}

export async function getSmartBenchmarkSectorsApi(organizationId) {
  const url = `${organizationId}/smart-benchmark/sectors`;
  return await apiRequest('GET', url, null, false);
}

export async function getSmartBenchmarkingOverviewApi(orgId, params) {

  const url = `${orgId}/smart-benchmark/overview`;

  return apiRequest('POST', url, params, false);
}

export async function getEmissionTrendApi(orgId, params) {

  const url = `${orgId}/smart-benchmark/trend`;

  return apiRequest('POST', url, params, false);
}
